/**
 * @generated SignedSource<<640afd1854661c93125c7711566df49c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UserRecordActionType = "retention" | "signup";
export type UserRecordRecordableType = "Campaign";
export type CreateUserRecordMutationInput = {
  actionType: UserRecordActionType;
  clientMutationId?: string | null;
  recordableId?: string | null;
  recordableType?: UserRecordRecordableType | null;
};
export type RootUserRecordMutation$variables = {
  input: CreateUserRecordMutationInput;
};
export type RootUserRecordMutation$data = {
  readonly createUserRecord: {
    readonly success: boolean;
  };
};
export type RootUserRecordMutation = {
  response: RootUserRecordMutation$data;
  variables: RootUserRecordMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateUserRecord",
    "kind": "LinkedField",
    "name": "createUserRecord",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RootUserRecordMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RootUserRecordMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "551b9a0276fbd98ff5d0a3569ab60076",
    "id": null,
    "metadata": {},
    "name": "RootUserRecordMutation",
    "operationKind": "mutation",
    "text": "mutation RootUserRecordMutation(\n  $input: CreateUserRecordMutationInput!\n) {\n  createUserRecord(input: $input) {\n    success\n  }\n}\n"
  }
};
})();

(node as any).hash = "384b8c3d441e7152449e65a2a9707593";

export default node;
